import {  NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RolesComponent } from './roles.component';
import { PermissionsComponent } from './permissions/permissions.component';
import { PermissionsetsComponent } from './permissionsets/permissionsets.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AuthModule } from '../core/auth.module';
import { RouterModule } from '@angular/router';
import { ClipboardModule } from 'ngx-clipboard';
import { BBSFControlsModule } from 'bbsf-controls';
import { RolesRoutingModule } from './roles-routing.module';
import { BlockUIModule } from 'ng-block-ui';
import { DataSecretService } from '../shared/Services/data.service';
import { PermissionSetInfoComponent } from './permission-set-info/permission-set-info.component';
import { SubheaderModule } from '../_layout/components/subheader/subheader.module';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { MatMenuModule } from '@angular/material/menu';
import { InlineSVGModule } from 'ng-inline-svg';
import { EmptyDataModule } from '../empty-data/empty-data.module';
import { AuthService, BBSFTranslateService, EnvironmentService, UtilityService } from 'bbsf-utilities';
import { PermissionSetService } from '../shared/Services/PermissionSetService.service';
import { PermissionsService } from '../shared/Services/PermissionsService.service';

@NgModule({
  declarations: [RolesComponent, PermissionsComponent, PermissionsetsComponent, PermissionSetInfoComponent],
  imports: [
    RolesRoutingModule,
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
    AuthModule,
    RouterModule,
    CommonModule,
    ClipboardModule,
    BlockUIModule.forRoot(),
    ReactiveFormsModule,
    FormsModule,
    BBSFControlsModule,
    SubheaderModule,
    NgbModule,
    MatMenuModule,
    InlineSVGModule,
    EmptyDataModule
  ],
  providers:[
    EnvironmentService,
    DataSecretService,
    UtilityService,
    AuthService,
    BBSFTranslateService,
    DatePipe,
    PermissionSetService,
    PermissionsService

 
  ]
})
export class RolesModule { }
